import { createLoadingReducer } from './utils';
import { BookingSettings } from '@/types';

export default createLoadingReducer<BookingSettings>('BOOKING_SETTINGS');
